import React, { useEffect, useState } from 'react';
import { Button, Col, Row, Space } from 'antd';
import Limits, { LimitsFormInputs } from '../../Limits/limits';

type FirstStepProps = {
  goToNext: () => void;
  goToPrevious: () => void;
  limit: LimitsFormInputs;
  setLimit: (data: LimitsFormInputs) => void;
};

const ThirdStep: React.FC<FirstStepProps> = ({ goToNext, goToPrevious, limit, setLimit  }) => {
  const [submitForm, setSubmitForm] = useState<boolean>(false);

  const validateToNext = () => {
    setSubmitForm(true);
  }

  useEffect(() => {
    if(limit !== undefined && limit !== null){
      goToNext();
    }
  }, [limit]);

  return (
    <>
      <Row gutter={24}>
        <Col span={24}>
          <Limits
            limit={ limit }
            setLimit={ setLimit }
            submitForm={ submitForm }
          />
        </Col>
      </Row>
      <Col span={32} style={{ textAlign: 'center', marginTop: '40px' }} >
        <Space>
          <Button onClick={ goToPrevious } >
            Anterior
          </Button>
          <Button type="primary" onClick={ validateToNext }>
            Siguiente
          </Button>
        </Space>
      </Col>
    </>
  );
}

export default ThirdStep;